export default __webpack_public_path__ + "static/media/mobile_money.e091de1b.jpg";